import { BulkActionsVariant, BulkEntityActionItem } from "components/BulkActions/types";

import { RoleBinding } from "../types";
import { IdpGroupRolesMutationVariables } from "./useIdpGroupRolesBulkActions/types";

export enum IdpGroupRolesBulkActions {
  Delete = "Delete",
}

export type IdpGroupRolesBulkActionsAnalyticsPayload = {
  view: BulkActionsVariant;
  metadata: Record<string, string | boolean>;
};

export type IdpGroupRolesBulkActionsSelectedAction = BulkEntityActionItem<
  IdpGroupRolesBulkActions,
  RoleBinding,
  IdpGroupRolesMutationVariables
>;
